import React       from "react";
import PropTypes   from "prop-types";
import Translation from "../../../../commons/i18n/Translation";

import Svg          from "../../../../../svg/Svg";

export default class SearchInputField extends React.Component {

    static propTypes = {
        query : PropTypes.string,
        onChangeQuery : PropTypes.func
    };

    static defaultProps = {
        query : "",
        onChangeQuery: () => {}
    };

    render = () => (
        <div className="mywort-box mywort-box--sm mywort-box--white">
            <div className="mywort-box__body">
                <div className="input-lined input-lined--keep-label">
                    <form onSubmit={() => this.props.onChangeQuery(this.props.query)} style={{'margin':0}}>
                        <input
                            ref={(input) => { this.queryInput = input; }}
                            type="search"
                            id="search-field"
                            value={this.props.query}
                            onChange={this.props.onChangeQuery}
                            required/>
                        <span className="input-lined__bar"></span>
                        <label className="input-lined__label">{Translation.translate("public.search") + '...'}</label>
                        <button type="submit" className="input-lined__icon">
                            <Svg id="search" className="input-lined__icon__svg"/>
                        </button>
                    </form>
                </div>
            </div>
        </div>
    );
}



// WEBPACK FOOTER //
// ./js/mywort/frontend/pages/search/desktop/SearchInputField.jsx